export class ClinicSublocationModel {
    sublocation_id: number;
    sublocation_code: string;
    sublocation_desc: string;
    specie: number;
    category: string;
    occupied: number;
    type: string;
    size: string;
    note: string;
    clinic_no: number;
    location_id: number;

    constructor(
        sublocation_id: number,
        sublocation_code: string,
        sublocation_desc: string,
        specie: number,
        category: string,
        occupied: number,
        type: string,
        size: string,
        note: string,
        clinic_no: number,
        location_id: number
    ) {
        this.sublocation_id = sublocation_id;
        this.sublocation_code = sublocation_code;
        this.sublocation_desc = sublocation_desc;
        this.specie = specie;
        this.category = category;
        this.occupied = occupied;
        this.type = type;
        this.size = size;
        this.note = note;
        this.clinic_no = clinic_no;
        this.location_id = location_id;
    }
}
